import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import ButtonPrimary from "../ButtonPrimary";

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "Massage Services", href: "/massage-services" },
  { label: "Events", href: "/events" },
  { label: "Matrix Drops", href: "/matrix-drops" },
  { label: "Matrix Drops Protocol", href: "/matrix-drops-protocol" },
];

export default function Footer() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setShowBackToTop(window.scrollY > 120);
    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    return () => window.removeEventListener("scroll", updateVisibility);
  }, []);

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <a href="/" className={styles.brandName}>
            Harmony of Soul
          </a>
          <p>Holistic wellbeing through massage, events, and Matrix Drops.</p>
        </div>

        <nav className={styles.navigation} aria-label="Footer navigation">
          <h2 className={styles.sectionTitle}>Explore</h2>
          <ul className={styles.linkList}>
            {footerLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} className={styles.link}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.booking}>
          <h2 className={styles.sectionTitle}>Ready to feel better?</h2>
          <p>Take the next step on your wellbeing journey.</p>
          <ButtonPrimary url="/booking" label="Book an appointment" />
        </div>
      </div>

      <div className={styles.bottom}>
        <p>© {new Date().getFullYear()} Harmony of Soul</p>
        <a href="#top" className={styles.link}>
          Back to top
        </a>
      </div>
      {showBackToTop && (
        <a href="#top" className={styles.backToTop} aria-label="Back to top" title="Back to top">
          <Icon icon="tabler:arrow-up" aria-hidden="true" />
        </a>
      )}
    </footer>
  );
}
